import React from 'react';
import { McProfile } from '../../../store/gamingStore';
import { Palette, Plus, Upload, Trash2 } from 'lucide-react';

interface Props {
  profile: McProfile;
}

const ProfileResourcePacksTab: React.FC<Props> = ({ profile }) => {
  const packs = profile.resourcePacks || [];

  return (
    <div className="max-w-7xl mx-auto px-6 py-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-semibold text-text-primary">
          Resource Packs ({packs.length})
        </h2>
        <div className="flex items-center gap-2">
          <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-bg-secondary border border-border-color text-xs text-text-secondary hover:text-text-primary hover:border-gaming-accent/50 transition-colors">
            <Upload className="w-3.5 h-3.5" />
            Importer
          </button>
          <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-gaming-accent/10 border border-gaming-accent/30 text-xs text-gaming-accent hover:bg-gaming-accent/20 transition-colors">
            <Plus className="w-3.5 h-3.5" />
            Ajouter
          </button>
        </div>
      </div>

      {packs.length === 0 ? (
        <div className="text-center py-16">
          <Palette className="w-12 h-12 text-text-muted mx-auto mb-3" />
          <p className="text-sm text-text-secondary">Aucun resource pack</p>
          <p className="text-xs text-text-muted mt-1">Ajoutez des resource packs pour personnaliser vos textures</p>
        </div>
      ) : (
        <div className="space-y-1">
          {packs.map((pack, i) => (
            <div key={i} className="flex items-center justify-between bg-bg-secondary border border-border-color rounded-lg px-3 py-2 group">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded bg-purple-500/10 border border-purple-500/20 flex items-center justify-center">
                  <Palette className="w-4 h-4 text-purple-400" />
                </div>
                <div>
                  <p className="text-sm text-text-primary font-medium">{pack.name}</p>
                  <p className="text-[10px] text-text-muted">{pack.file_name} · {pack.source}</p>
                </div>
              </div>
              <button className="p-1 rounded text-text-muted hover:text-red-400 opacity-0 group-hover:opacity-100 transition-all">
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProfileResourcePacksTab;
